<template>
  <div class="jp-main">
    <job-page :job-ssr="jobSsr" />
  </div>
</template>

<script>
import { getJobLocalePaths } from '../../../libs/job'
import JobPage from '../../../components/job/jobPage'

export default {
  asyncData({ params, payload, store } = {}) {
    // Use job payload injected by site generation script
    // if match route job ID
    if (payload && payload._id === params.id) {
      // Set localised path mapping
      store.commit('locale/setPageLocalePaths', getJobLocalePaths(payload))

      return {
        jobSsr: payload,
      }
    }
  },
  components: {
    'job-page': JobPage,
  },
  data() {
    return {
      jobSsr: null,
    }
  },
  name: 'JobPage',
}
</script>

<style lang="postcss" scoped>
.jp-main {
  @apply flex w-full justify-center;
}
</style>
